export const environment = {
  apiUrl: 'https://api.shutterflow.io',
  frontBaseUrl: 'https://shutterflow.io',
  production: true,
  stripePublicKey: 'pk_live_51R8iiRGY3YzFrj5W2SrffPvgRUB6fSXW1b4HYiGW54I75S3BwmOz2m1KnEoxLBYqq4VRqRBhJROrmuOKro7HJt8K00XBmLWnnz',
  imgStrategy: 'resolve' as const,  // 'cache' = /media/cache/<filter>/..., 'resolve' = /media/cache/resolve/...
  metaPixel: {
    enabled: true,
    id: '24660538650306383',
  },
  sentry: {
    dsn: 'https://918be85696e132d28e74f082310c5117@o1171126.ingest.us.sentry.io/4509967804399616',
    enabled: true,
    environment: 'production',
    tracesSampleRate: 0.1,
  },
};
